function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  background: rgba(32, 36, 46, 0.56);\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: 99;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  background: #ffffff;\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%) scale(0.9);\n  width: 506px;\n  z-index: 100;\n  border-radius: 16px;\n  @media (max-width: 550px) {\n    width: 100vw;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 20px 0;\n  margin: auto 0;\n  text-align: center;\n  font-weight: 500;\n  font-size: 1rem;\n  line-height: 1.5rem;\n  letter-spacing: 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 16px 12px;\n  background: #fef7ea;\n  text-align: center;\n  border-radius: 8px;\n  margin: 8px 24px;\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  jusify-content: center;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  overflow: scroll;\n  height: 320px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  padding: 8px 24px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: 400;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  letter-spacing: 0;\n  text-align: justify;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  display: inline-flex;\n  align-items: center;\n  cursor: pointer;\n  user-select: none;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  display: none;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  width: 26px;\n  height: 26px;\n  min-width: 26px;\n  border: 1px solid #ccc;\n  background: white;\n  border-radius: 6px;\n  transition: all 0.2s;\n  position: relative;\n\n  ",
        ":checked + & {\n    background-color: #3498db;\n    border-color: #3498db;\n  }\n\n  ",
        ':checked + &::after {\n    content: "";\n    position: absolute;\n    left: 7px;\n    top: 2px;\n    width: 10px;\n    height: 14px;\n    border: solid white;\n    border-width: 0 2px 2px 0;\n    transform: rotate(45deg);\n  }\n'
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: 8px;\n  font-size: 16px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 8px 24px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 16px 24px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  padding: 14px 0;\n  background: #2f4f92;\n  border: none;\n  border-radius: 6px;\n  color: #ffffff;\n  cursor: pointer;\n\n  &:active {\n    background: #2e5991;\n  }\n\n  &:disabled {\n    background: #e9ebef;\n    color: #979fa8;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  position: fixed;\n  background: rgba(250, 250, 251, 0.24);\n  padding: 10px;\n  border-radius: 50%;\n  left: calc(50% + 260px);\n  @media (max-width: 550px) {\n    background: none;\n    left: auto;\n    right: 2%;\n    top: 2%;\n    filter: invert(1);\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { FilledInfoIcon, WhiteCloseIcon } from "@pancakeswap/uikit/src/components/Svg";
import { useEffect, useState } from "react";
import styled from "styled-components";
var Backdrop = styled.div.withConfig({
    componentId: "sc-b43a0334-0"
})(_templateObject());
var Alert = styled.div.withConfig({
    componentId: "sc-b43a0334-1"
})(_templateObject1());
var Dropbox = function(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Backdrop, {}),
            /*#__PURE__*/ _jsx(Alert, {
                children: children
            })
        ]
    });
};
var DisclamerHeader = styled.div.withConfig({
    componentId: "sc-b43a0334-2"
})(_templateObject2());
var Warning = styled.div.withConfig({
    componentId: "sc-b43a0334-3"
})(_templateObject3());
var DisclaimerBody = styled.div.withConfig({
    componentId: "sc-b43a0334-4"
})(_templateObject4());
var DisclaimerBodyText = styled.p.withConfig({
    componentId: "sc-b43a0334-5"
})(_templateObject5());
var CheckboxContainer = styled.label.withConfig({
    componentId: "sc-b43a0334-6"
})(_templateObject6());
var HiddenCheckbox = styled.input.attrs({
    type: "checkbox"
}).withConfig({
    componentId: "sc-b43a0334-7"
})(_templateObject7());
var StyledCheckbox = styled.span.withConfig({
    componentId: "sc-b43a0334-8"
})(_templateObject8(), HiddenCheckbox, HiddenCheckbox);
var LabelText = styled.span.withConfig({
    componentId: "sc-b43a0334-9"
})(_templateObject9());
var CustomCheckbox = function(param) {
    var label = param.label, checked = param.checked, onChange = param.onChange;
    return /*#__PURE__*/ _jsxs(CheckboxContainer, {
        children: [
            /*#__PURE__*/ _jsx(HiddenCheckbox, {
                checked: checked,
                onChange: onChange
            }),
            /*#__PURE__*/ _jsx(StyledCheckbox, {}),
            /*#__PURE__*/ _jsx(LabelText, {
                children: label
            })
        ]
    });
};
var AgreementContainer = styled.div.withConfig({
    componentId: "sc-b43a0334-10"
})(_templateObject10());
var AgreementButtonContainer = styled.div.withConfig({
    componentId: "sc-b43a0334-11"
})(_templateObject11());
var AgreementButton = styled.button.withConfig({
    componentId: "sc-b43a0334-12"
})(_templateObject12());
var CloseButton = styled.a.withConfig({
    componentId: "sc-b43a0334-13"
})(_templateObject13());
var Disclamer = function() {
    var ref = useState(false), checked = ref[0], setChecked = ref[1];
    var ref1 = useState(null), accepted = ref1[0], setAccepted = ref1[1];
    useEffect(function() {
        var agreement = localStorage.getItem("agreement");
        setAccepted(agreement != null);
    }, [
        setAccepted
    ]);
    useEffect(function() {
        document.body.style.overflow = accepted ? "" : "hidden";
    }, [
        accepted
    ]);
    var accept = function() {
        localStorage.setItem("agreement", "accepted");
        setAccepted(true);
    };
    var close = function() {
        console.debug("Close dialog");
    };
    if (accepted == null || accepted) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(Dropbox, {
        children: [
            /*#__PURE__*/ _jsx(CloseButton, {
                onClick: close,
                href: "https://www.stobox.io",
                children: /*#__PURE__*/ _jsx(WhiteCloseIcon, {
                    width: 14,
                    height: 14
                })
            }),
            /*#__PURE__*/ _jsx(DisclamerHeader, {
                children: "Disclaimer"
            }),
            /*#__PURE__*/ _jsxs(Warning, {
                children: [
                    /*#__PURE__*/ _jsx(FilledInfoIcon, {}),
                    " Please Review the Following Terms Before Proceeding"
                ]
            }),
            /*#__PURE__*/ _jsxs(DisclaimerBody, {
                children: [
                    /*#__PURE__*/ _jsx(DisclaimerBodyText, {
                        children: "Stobox DS Swap is operated by Stobox Innovations Limited, a company incorporated in the British Virgin Islands on the 11th day of May, 2022 under the BVI Business Companies Act, 2004, with BVI COMPANY NUMBER 2098354. Stobox DS Swap facilitates the trading of the STBX token, which is issued by Stobox Tokenized Equities Limited, a related company incorporated in the British Virgin Islands on the 7th day of December, 2023, under BVI Company Number 2137812. Both Stobox Innovations Limited and Stobox Tokenized Equities Limited are affiliated entities within the Stobox group of companies. Pursuant to the BVI Securities and Investment Business Act, 2010 (SIBA), Stobox DS Swap operates in compliance with the regulatory framework of the British Virgin Islands. Its activities are structured to facilitate the trading of tokenized assets issued solely by affiliated entities within the Stobox group, ensuring that no investment business license or brokerage license is required."
                    }),
                    /*#__PURE__*/ _jsx(DisclaimerBodyText, {
                        children: "DS Swap is a purely technological solution designed to enable the trading of tokenized assets issued exclusively by entities within the Stobox group of companies. The platform is designed to support decentralized financial operations and complies with exemptions provided under the Markets in Crypto-Assets Regulation (MiCA), without performing functions subject to regulation under the Markets in Financial Instruments Directive (MiFID II). The platform does not engage in advertising or targeted marketing of financial instruments. Access to DS Swap may be restricted or unavailable in certain jurisdictions due to regulatory constraints."
                    }),
                    /*#__PURE__*/ _jsx(DisclaimerBodyText, {
                        children: "By using Stobox DS Swap, you acknowledge that you have read, understood, and accepted these terms, and you assume full responsibility for ensuring compliance with your jurisdiction\u2019s laws and for any associated risks"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(AgreementContainer, {
                children: /*#__PURE__*/ _jsx(CustomCheckbox, {
                    label: "I have read and accept the notice",
                    checked: checked,
                    onChange: function() {
                        return setChecked(!checked);
                    }
                })
            }),
            /*#__PURE__*/ _jsx(AgreementButtonContainer, {
                children: /*#__PURE__*/ _jsx(AgreementButton, {
                    disabled: !checked,
                    onClick: accept,
                    children: "Agree and Continue"
                })
            })
        ]
    });
};
export default Disclamer;
